import React, { useState } from 'react';
import './CoachCodeCard.css';

function CoachCodeCard({ code }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <div className="coach-code-card">
      <div className="coach-code-label">Your Coach Code</div>
      <div className="coach-code-value">{code}</div>
      <button onClick={handleCopy} className="coach-code-copy">
        {copied ? '✓ Copied!' : 'Copy Code'}
      </button>
      <p className="coach-code-hint">
        Share this code with your students. They'll enter it in the 3 Pillars Putting app to connect to you.
      </p>
    </div>
  );
}

export default CoachCodeCard;
